import Link from 'next/link';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
interface CategoryBannerProps {
  className?: string;
}
const EshopBanner: React.FC<CategoryBannerProps> = ({
  className = "mb-6 mt-2"
}) => {
  const {
    t
  } = useTranslation('menu');
  return <Link href="/e-shop" className={`block md:hidden w-full ${className}`} data-sentry-element="Link" data-sentry-component="EshopBanner" data-sentry-source-file="e-shop-home.tsx">
      <div className="relative flex justify-center items-center w-full max-w-full h-32 sm:h-[600px] rounded-3xl">
        <span className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
          <span className="bg-black bg-opacity-30 backdrop-blur-sm px-3 py-1 rounded-3xl text-white text-2xl font-bold">
            {t('menu-shop')}
          </span>
        </span>
        <div className="absolute inset-0 bg-yellow-600 rounded-3xl blur-xl opacity-70 z-0" />
        <Image src="/assets/images/og-image-shop.jpg" alt="E-SHOP" fill className="relative z-0 rounded-3xl object-cover" data-sentry-element="Image" data-sentry-source-file="e-shop-home.tsx" />
      </div>
    </Link>;
};
export default EshopBanner;